export default "__VITE_ASSET__DvJKsQTb__"